import React from "react";

const USDIconSVG = ({ w, h }) => {
  return (
    <svg
      data-v-1fc207f0=""
      width={w}
      height={h}
      viewBox="0 0 11 19"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        data-v-1fc207f0=""
        d="M5.36512 16.7472C4.42712 16.7042 3.55912 16.4819 2.76112
             16.0805C1.97712 15.6647 1.30512 15.0983 0.745117
              14.3814L2.00512 13.1985C2.94312 14.3456 4.06312
               14.9908 5.36512 15.1341V10.2521C4.02112 9.90794
                3.02712 9.42045 2.38312 8.78958C1.73912 8.15871
                1.41712 7.36295 1.41712 6.4023C1.41712 5.34129
                 1.76712 4.49535 2.46712 3.86447C3.18112
                 3.21926 4.14712 2.86081 5.36512 2.78912V0.875H6.56212V2.83214C8.07412
                 3.01853 9.25712 3.6494 10.1111 4.72475L8.85112 5.86463C8.31912
                  5.10471 7.55612 4.63873 6.56212 4.46667V8.81109C7.90612
                   9.19821 8.90012 9.71438 9.54412 10.3596C10.1881
                   11.0048 10.5101 11.8149 10.5101 12.7899C10.5101
                   13.8796 10.1461 14.7757 9.41812 15.4783C8.70412
                    16.1808 7.75212 16.5966 6.56212 16.7257V18.6828H5.36512V16.7472ZM8.76712 12.8544C8.76712 12.2952 8.59912 11.8436 8.26312 11.4995C7.94112 11.141 7.37412 10.8327 6.56212 10.5747V15.1126C7.27612 15.041
                    7.82212 14.8115 8.20012 14.4244C8.57812 14.0373
                     8.76712 13.514 8.76712 12.8544ZM5.36512
                      4.42366C4.66512 4.46667 4.11912 4.65306 3.72712 4.98284C3.34912
                       5.31261 3.16012 5.76426 3.16012 6.33778C3.16012
                       6.83961 3.32812 7.25541 3.66412 7.58519C4.00012 7.91496 4.56712
                       8.20889 5.36512 8.46697V4.42366Z"
      ></path>
    </svg>
  );
};

export default USDIconSVG;
